module.exports = __webpack_public_path__ + "static/img/bg_theme_green@2x.088d507.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_green@2x.png
// module id = p50c
// module chunks = 1